export default __webpack_public_path__ + "static/media/logo_small.6a9c0441.svg";